import { render } from "./testimonials-hackathon.vue?vue&type=template&id=e9a5c170&scoped=true"
import script from "./testimonials-hackathon.vue?vue&type=script&lang=js"
export * from "./testimonials-hackathon.vue?vue&type=script&lang=js"

import "./testimonials-hackathon.vue?vue&type=style&index=0&id=e9a5c170&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a5c170"]])

export default __exports__